import { Component, EventEmitter,TemplateRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';

@Component({
  selector: 'app-CutomerCommentView',
  templateUrl: './CutomerCommentView.component.html',
  styleUrls: ['./CutomerCommentView.component.scss']
})
export class CutomerCommentViewComponent implements OnInit {

  @Input() Customer_Inner:Customer_List_Interface

  @Output() OnBack_Comment_Action = new EventEmitter<number>();
  Token:String=""
  Proccessing:boolean=false
  page:number=0

  ngOnChanges(changes: SimpleChanges): void {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Read_Comment()
  }

  constructor(
    private Customer_Service: CustomerService,
    private Alertify_Service:AlertifyService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
  }


  OnSet_Back_CommentView(){
    this.OnBack_Comment_Action.emit(-1);
  }

  Data_Seleted_Delete:General_Interface=Empty_General_Interface()
  DataList_Comment: Array<General_Interface> = []
  Data_Seleted_Comment:General_Interface=Empty_General_Interface()

  Read_Comment(){
    this.Proccessing=true
    this.Customer_Service.GetCustomerComment(this.Token,this.Customer_Inner.id,1).subscribe(
      data=>{
        this.Proccessing=false
        this.DataList_Comment=data
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Customer_Service.CommentDelete(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")
        this.Read_Comment()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  modalRef_Delete: any;
  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  EditDsc:String=''
  modalRef_Edit:any
  openModal_Edit(template: TemplateRef<any>, item: General_Interface) {
    this.EditDsc=item.title
    this.Data_Seleted_Comment=item
    this.modalRef_Edit = this.modalService.show(template);
  }

  Edit(){
    this.Data_Seleted_Comment.DeletingProccess=true
    this.modalRef_Edit.hide()
    this.Customer_Service.CommentEdit(this.Data_Seleted_Comment.id,this.EditDsc,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Updated successfully.")
        this.Data_Seleted_Comment.title = data['dsc']
        this.Data_Seleted_Comment.DeletingProccess=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
